import { cdnBase } from "../../const";

export default {
  en_ca: {
    langKeys: {
      en_ca: 'English (CAN)',
      en_us: 'English (US)',
      en_gb: 'English (UK)',
      en_au: 'English (AU)',
      fr_fr: 'France',
      nl_nl: 'Netherlands',
      de_de: 'Germany',
      it_it: 'Italy',
      cz_cz: 'Czech Republic',
      hu_hu: 'Hungary',
      pl_pl: 'Poland',
      ro_ro: 'Romania',
      sk_sk: 'Slovakia',
      mx_mx: 'Mexico',
      es_es: 'Spain',
      tr_tr: 'Turkey',
      hr_hr: 'Croatia',
      ru_ru: 'Russia'
    },
    interstitial: {
      heading: "Leaving this Site",
      copy: `By clicking "continue" you'll be leaving this web site and landing on a third-party site, which is governed by different terms and privacy policies.`,
      continue: "Continue",
      cancel: "Cancel",
    },
    ga: {
      copy:
        "We use cookies on this site to help improve your experience. By using this site, you consent to the use of cookies. Our Cookies Policy explains what cookies are, how we use cookies, how third­parties we may partner with may use cookies on the Service, your choices regarding cookies and further information about cookies.",
      continue: "Continue",
      disable: "Disable Cookies",
    },
    brand: "Mighty Express",
    applinks: {
      apple: "LINK TO APPLE APP",
      google: "LINK TO GOOGLE APP",
    },
    chooseRegion: "Choose Language",
    loading: "Loading",
    select: "Select",
    clearAll: "Clear All",
    filters: "Filters",
    details: "Details",
    instructions: "download Instructions",
    videoInstructions: "video Instructions",
    warnings: {
      enableIframes: "You Must Enable iFrames to view this video",
    },
    helmet: {
      siteTitle: " | Mighty Express ",
      meta_description:
        "Mighty Express is an exciting new preschool show where teams of trains and kids work togetherto keep things moving!Don’t miss this action-packed railway world!",
      tags: `preschool, preschool tv, kids shows, kids tv, preschool kids tv, preschool cartoons, kids cartoons, train cartoons, good preschool shows, good kids cartoons, like Paw Patrol, Mighty Express, train shows, train cartoon, best preschool cartoon, preschool shows 2020, preschool shows 2021, preschool educational cartoons, preschool educational shows, best preschool shows, best preschool cartoons`,
    },
    navigation: {
      mainmenu: [
        {
          type: "internal",
          href: "/meettheheroes",
          display: "MEET THE TEAM",
          icon: null,
        },
        {
          type: "internal",
          href: "/toys",
          display: "Toys",
          icon: null,
        },
        {
          type: "internal",
          href: "/activities",
          display: "Activities",
          icon: null,
        },
        
        {
          type: "internal_hash",
          href: "#wheretowatch",
          display: "Where to Watch",
          icon: null,
        },
        {
          type: "internal_hash",
          href: "#app",
          display: "App",
          icon: null,
        },
        // {
        //   type: "internal",
        //   href: "/valentines",
        //   display: "Valentine's Goodies",
        //   icon: null,
        // },
      ],
      social: [
        {
          type: "interstitial",
          href: "https://www.youtube.com/user/OfficialPawPatrol",
          display: "youtube",
          icon: null,
        },
        {
          type: "interstitial",
          href: "https://www.facebook.com/mightyexpressofficial/",
          display: "facebook",
          icon: null,
        },
        {
          type: "interstitial",
          href: "https://www.instagram.com/mightyexpressofficial/?hl=en",
          display: "instagram",
          icon: null,
        },
      ],
    },
    whereToBuy: {
      title: "Where to Buy",
      retailers: [
        {
          name: 'toyrus',
          href: 'https://www.toysrus.ca/en/search?q=mighty%20express',
          img: `${cdnBase}retailers/Logo-Toysrus.png`
        },
        {
          name: 'walmart',
          href: 'https://www.walmart.ca/brand/mighty-express/51337575',
          img: `${cdnBase}retailers/Logo-Walmart.png`
        },
        {
          name: 'mastermind_toys',
          href: 'https://www.mastermindtoys.com/pages/search-results?q=mighty%20express&narrow=%5B%5B%22Brand%22%2C%22BRAND_Mighty%20Express%22%5D%5D&disable_semantics=1',
          img: `${cdnBase}retailers/Logo-Mastermind.png`
        },
        {
          name: 'indigo',
          href: 'https://www.chapters.indigo.ca/en-ca/toys/mighty-express-farm-station-adventure/778988359778-item.html',
          img: `${cdnBase}retailers/Logo-Indigo.png`
        },
        {
          name: 'amazon',
          href: 'https://www.amazon.ca/stores/page/C4EB3E54-3040-4FD4-B659-A62C0FBC380A',
          img: `${cdnBase}retailers/Logo-Amazon.png`
        }
      ]
    },
    footer: {
      brand: "Spin Master",
      contactUs: "Contact Us",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      support: "Support",
      cookies: "Cookies",
      copy: "Spin Master Ltd. All rights reserved.",
      contactLink:
        "https://www.spinmaster.com/contact-us.php?userLoc=us&display=customer_service_info",
      privacyLink: "https://www.spinmaster.com/privacy-policy.php?userLoc=us",
      termsLink: "https://www.spinmaster.com/terms-of-service.php?userLoc=us",
      supportLink: "https://www.spinmaster.com/support.php?userLoc=us",
    },
    home: {
      title: "Home",
      whereToBuy: "Where To Buy",
      videoCTA: {
        src: `${cdnBase}videos/EN-US_MTE_MainTrailer_1920x1080_H264_2ch_Post_Bug.mp4`,
      },
      trainProps: [
        {
          props: [],
        },
        {
          props: [
            {
              sheet: `${cdnBase}scroll/1/tracksville-mountain.png`,
              animated: false,
              autoPlay: false,
              id: 2,
              // instance: {}
            },
            {
              sheet: `${cdnBase}scroll/Sprite+Sheets/train-signal-sprite.png`,
              fps: 24,
              heightFrame: 300,
              widthFrame: 550,
              steps: 54,
              animated: true,
              autoPlay: false,
              id: 0,
              type: "wide",
              // instance: {}
            },
            {
              sheet: `${cdnBase}scroll/1/goatTest.png`,
              fps: 24,
              heightFrame: 300,
              widthFrame: 350,
              steps: 55,
              animated: true,
              autoPlay: false,
              id: 3,
              // instance: {}
            },
          ],
        },
        {
          props: [
            {
              sheet: `${cdnBase}scroll/1/sign-centralsquarestation.png`,
              animated: false,
              autoPlay: false,
              id: 1,
              // instance: {}
            },
            {
              sheet: `${cdnBase}scroll/2/rock-bush-fountain.png`,
              animated: false,
              autoPlay: false,
              id: 6,
              // instance: {}
            },
            {
              sheet: `${cdnBase}scroll/2/cactus%2Bsign-sprite.png`,
              fps: 24,
              heightFrame: 300,
              widthFrame: 350,
              steps: 47,
              animated: true,
              autoPlay: false,
              id: 4,
              // instance: {}
            },
            {
              sheet: `${cdnBase}scroll/2/cactus-rock.png`,
              animated: false,
              autoPlay: false,
              id: 5,
              // instance: {}
            },
          ],
        },
        {
          props: [
            {
              sheet: `${cdnBase}scroll/2/sign-missionstation.png`,
              animated: false,
              autoPlay: false,
              id: 8,
              // instance: {}
            },
            {
              sheet: `${cdnBase}scroll/3/hills.png`,
              animated: false,
              autoPlay: false,
              id: 10,
              type: "wide",
              // instance: {}
            },
            {
              sheet: `${cdnBase}scroll/Sprite+Sheets/chicken-sprite.png`,
              fps: 24,
              heightFrame: 300,
              widthFrame: 400,
              steps: 17,
              animated: true,
              autoPlay: false,
              id: 9,
              type: "small",
              // instance: {}
            },

            {
              sheet: `${cdnBase}scroll/3/tree-bush.png`,
              animated: false,
              autoPlay: false,
              id: 13,
              // instance: {}
            },
          ],
        },
        {
          props: [
            {
              sheet: `${cdnBase}scroll/4/sign-train.png`,
              animated: false,
              autoPlay: false,
              id: 16,
              type: "small",
              // instance: {}
            },
            {
              sheet: `${cdnBase}scroll/Sprite+Sheets/bat-sprite.png`,
              fps: 24,
              heightFrame: 300,
              widthFrame: 400,
              steps: 22,
              animated: true,
              autoPlay: false,
              id: 14,
              // instance: {}
            },
          ],
        },
        {
          props: [
            {
              sheet: `${cdnBase}scroll/4/rock-tree.png`,
              animated: false,
              autoPlay: false,
              id: 15,
              // instance: {}
            },

            {
              sheet: `${cdnBase}scroll/4/tree-bush2.png`,
              animated: false,
              autoPlay: false,
              id: 17,
              type: "wide",
              // instance: {}
            },
          ],
        },
        {
          props: [
            {
              sheet: `${cdnBase}scroll/5/sign-train.png`,
              animated: false,
              autoPlay: false,
              id: 18,
              // instance: {}
            },
            {
              sheet: `${cdnBase}scroll/5/rock-tree.png`,
              animated: false,
              autoPlay: false,
              id: 19,
              // instance: {}
            },
            
            {
              sheet: `${cdnBase}scroll/5/tree-bush2.png`,
              animated: false,
              autoPlay: false,
              id: 20,
              // instance: {}
            },
            {
              sheet: `${cdnBase}scroll/Sprite+Sheets/bat-sprite.png`,
              fps: 24,
              heightFrame: 300,
              widthFrame: 400,
              steps: 22,
              animated: true,
              autoPlay: false,
              id: 21,
              // instance: {}
            },
            {
              sheet: `${cdnBase}sept+2021/app-icon.png`,
              animated: false,
              autoPlay: false,
              id: 22,
              // instance: {}
            },
          ],
        },
      ],
      commingsoon: {
        heading: "The train arrives at the station in:",
        subheading: "coming September 22nd to",
        social: {
          heading: `Let’s make tracks!`,
          icons: [
            {
              link: "https://www.youtube.com/user/OfficialPawPatrol",
              type: "youtube",
              img: `${cdnBase}universal/Social/YT-static.svg`,
              img2: `${cdnBase}universal/Social/YT-hover.svg`,
            },
            {
              link: "https://www.facebook.com/mightyexpressofficial/",
              type: "facebook",
              img: `${cdnBase}universal/Social/FB-static.svg`,
              img2: `${cdnBase}universal/Social/FB-hover.svg`,
            },
            {
              link: "https://www.instagram.com/mightyexpressofficial/?hl=en",
              type: "instagram",
              img: `${cdnBase}universal/Social/IG-static.svg`,
              img2: `${cdnBase}universal/Social/IG-hover.svg`,
            },
          ],
        },
      },
      sections: {
        audioQeues: [
          `${cdnBase}commingsoon/Mighty+Express+Theme+-+Band+Only.wav`,
          `${cdnBase}tracksville/104B+Nate+and+Max+Travelling+Cue+-+BQ100.wav`,
          `${cdnBase}centralSquare/Central+square+station+AMB+only+ep103B.wav`,
          `${cdnBase}missionStatement/Mission+station+AMB+only+ep103B.wav`,
          `${cdnBase}commingsoon/Mighty+Express+Theme+-+Band+Only.wav`,
        ],
        allaboard: {
          header1: `All aboard`,
          header2: `the Mighty Express!`,
          toast: 'toys available now!',
          vid: `${cdnBase}header/homepage_VIDEO_desktop_lores.mp4`,
          cta1: {
            copy: `watch trailer`,
            link: `${cdnBase}videos/EN-US_MTE_MainTrailer_1920x1080_H264_2ch_Post_Bug.mp4`,
          },
        },
        toystation: {
          header: `It's Toy Station!`,
          bgImg: `${cdnBase}sept+2021/BG_TOY.jpg`,
          mobileBgImg: `${cdnBase}sept+2021/BG_TOY_mobile.jpeg`,
          copy: `Recreate their favorite Mega Missions at home with Mighty Express toys! The universal track system lets you connect any set together so they can create their own Tracksville. With trains, figures, tracks, and stations, there's trainloads of fun to be had!`,
          cta1: {
            copy: `SEE THEM IN ACTION`,
            link: `${cdnBase}videos/EN-US_MTE_MainTrailer_1920x1080_H264_2ch_Post_Bug.mp4`,
          },
          cta2: {
            copy: `LEARN MORE`,
            link: `/toys`,
          },
        },
        story: {
          header: `First stop, Tracksville!`,
          bgImg: `${cdnBase}tracksville/tracksville-BG-full.jpg`,
          mobileBgImg: `${cdnBase}tracksville/tracksville-BG.jpg`,
          mobileFgImg: `${cdnBase}tracksville/tracksville-BG-full-mobile.jpg`,
          audio: `${cdnBase}tracksville/104B+Nate+and+Max+Travelling+Cue+-+BQ100.wav`,
          copy: `From the makers of PAW Patrol, welcome to the action-packed railway world of Mighty Express! In thrilling adventures perfect for preschoolers, a team of trains and kids work together to keep things moving across the city, no matter the trouble. Their main goal: delivering carloads of fun – on time, every time!`,
          subcopy: `Let’s keep this train moving!`,
        },
        characters: {
          header: `Next stop!`,
          copy: `Let’s meet everyone at Central Square Station!`,
          cta: {
            copy: `Meet the Heroes!`,
            link: `/meettheheroes`,
          },
          bgImg: `${cdnBase}centralSquare/centralsquare-BG-full.jpg`,
          mobileBgImg: `${cdnBase}centralSquare/centralsquare-BG.jpg`,
          mobileFgImg: `${cdnBase}centralSquare/centralsquare-BG-full-mobile.jpg`,
          audio: `${cdnBase}centralSquare/Central+square+station+AMB+only+ep103B.wav`,
        },
        printables: {
          header: `We’ve arrived at Mission Station!`,
          copy: `Get your little one's wheels turning with these fun, free activities!`,
          bgImg: `${cdnBase}missionStatement/mission-BG-full.jpg`,
          mobileBgImg: `${cdnBase}missionStatement/mission-BG.jpg`,
          mobileFgImg: `${cdnBase}missionStatement/mission-BG-full-mobile.jpg`,
          audio: `${cdnBase}missionStatement/Mission+station+AMB+only+ep103B.wav`,
          cta: {
            copy: `Learn More`,
            link: `/activities`,
          },
        },
        watch: {
          header: `WATCH ALL NEW EPISODES`,
          header2: `AVAILABLE NOW!`,
          bgImg: `${cdnBase}whereToWatch/wheretowatch-BG.jpg`,
          cta1: {
            img: `${cdnBase}whereToWatch/Netflix_Logo_RGB.png`,
            alt: "netflix",
            link: `https://www.netflix.com/title/81033141`,
          },
          cta2: {
            img: `${cdnBase}whereToWatch/yt_logo_rgb_light.png`,
            alt: "youtube",
            link: `https://www.youtube.com/playlist?list=PLU1E9f2XmDpagcpr2SE_q9mo7PkwDVvy9`,
          },
        },
        app: {
          header:  `Welcome to`,
          header2:  `App Station!`,
          copy: `The Mighty Express app follows the adventures of all your favorite characters in awesome missions and games! Kids will learn shapes, numbers, colors, basic math, improve their fine motor and problem-solving skills - all while having trainloads of fun!`,
          bgImg: `${cdnBase}app/app-BG-full.jpg`,
          cta1:{
            copy: `apple`,
            img: `${cdnBase}app/apple-store.svg`,
            src: `https://apps.apple.com/app/mighty-express-play-learn/id1528383439`
          },
          cta2:{
            copy: `google`,
            img: `${cdnBase}app/google-store.svg`,
            src: `https://play.google.com/store/apps/details?id=com.spinmaster.mightyexpressgamesworld`
          },
          carousel: [
            {
              img: `${cdnBase}sept+2021/New+App+Screenshots/1600-9.jpeg`,
              img_mobile: `${cdnBase}sept+2021/New+App+Screenshots/1600-9.jpeg`,
              alt: 'play app trailer',
              cta:{
                src: `${cdnBase}app/Mighty+Express_Nov2020_Xmas+Update_1920x1080.mp4`
              }
            },
            {
              img: `${cdnBase}sept+2021/New+App+Screenshots/1600-10+(1).jpeg`,
              alt: 'app screenshot'
            },
            {
              img: `${cdnBase}sept+2021/New+App+Screenshots/1600-14 (1).jpeg`,
              alt: 'app screenshot'
            },
            {
              img: `${cdnBase}sept+2021/New+App+Screenshots/1600-16 (1).jpeg`,
              alt: 'app screenshot'
            },
            {
              img: `${cdnBase}sept+2021/New+App+Screenshots/1600-17+(1).jpeg`,
              alt: 'app screenshot'
            },
            
          ]
        }
      },
    },
    characterpage: {
      header: ``,
      sections: [
        {
          display: "The Trains",
          id: "trains",
          meet: "Meet the other Trains!",
          bgImg: `${cdnBase}meetTheHeros/trains/CAROUSEL/NEW_Mission_BG_notracks.jpg`,
          characters: [
            {
              name: `Freight Nate`,
              header: `Super strong and super fast!`,
              copy: `Freight Nate is the mightiest and fastest train. With a giant magnet for lifting heavy loads and a powerful engine, one of Nate’s jobs is to muscle the freight through no matter what!`,
              audio: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Nate/NATE_CTA_REV1.wav`,
              img: `${cdnBase}meetTheHeros/trains/CAROUSEL/trains-NATE.png`,
              bioImg: `${cdnBase}meetTheHeros/trains/BIO+PAGES/bio-NATE.png`,
              bioCircle: `${cdnBase}meetTheHeros/trains/MEET+THE+OTHER+TRAINS/Nate-Circle.png`,
              grid: [
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Nate/Nate+Image+1.png`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Nate/Nate+Image+2.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Nate/Nate+Image+4.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Nate/Nate+Image+5.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Nate/gallery-NATE-musicvideo-thumb.jpg`,
                movie: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Nate/NATE_NateBeNimble_H264_20Mbps_Clean_200720_vimeo.mp4`,
              },
            },
            {
              name: `Mechanic Milo`,
              header: `He can fix it!`,
              copy: `Mechanic Milo has the right tool for the right job! Obsessed with fixing things, Milo is equipped with a multi-tool arm with a huge array of attachments. Milo’s chief job is keeping the tracks in tip top shape, but will happily tackle any puzzle you throw at him.`,
              audio: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Milo/MILO_CTA_REV1.wav`,
              img: `${cdnBase}meetTheHeros/trains/CAROUSEL/trains-MILO.png`,
              bioImg: `${cdnBase}meetTheHeros/trains/BIO+PAGES/bio-MILO.png`,
              bioCircle: `${cdnBase}meetTheHeros/trains/MEET+THE+OTHER+TRAINS/Milo-Circle.png`,
              grid: [
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Milo/Milo+Image+2.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Milo/Milo+Image+3.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Milo/Milo+Image+4.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Milo/Milo+Image+5.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Milo/Milo+Image+1-VIdeo+Thumb.jpg`,
                movie: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Milo/Milo_VideoClip.mov`,
              },
            },
            {
              name: `Build-It Brock`,
              header: `There's nothing he can't build!`,
              copy: `Build-It Brock's got this! A powerful, cement-mixer-backed train with big jobs and big ideas, Brock builds whatever the town needs – bridges, train bays, concrete pads, or tunnels through the mountain.`,
              audio: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Brock/BROCK_CTA_REV1.wav`,
              img: `${cdnBase}meetTheHeros/trains/CAROUSEL/trains-BROCK.png`,
              bioImg: `${cdnBase}meetTheHeros/trains/BIO+PAGES/bio-BROCK.png`,
              bioCircle: `${cdnBase}meetTheHeros/trains/MEET+THE+OTHER+TRAINS/Brock-Circle.png`,
              grid: [
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Brock/Brock+Image+1.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Brock/Brock+Image+2.png`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Brock/Brock+Image+4.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Brock/Brock+Image+5.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Brock/Brock+Image+3-Video+Thumb.jpg`,
                movie: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Brock/Brock_Video+Clip.mov`,
              },
            },
            {
              name: `Farmer Faye`,
              header: `Loud and proud!`,
              copy: `Farmer Faye couldn’t be happier to haul, ya’ll! A cowboy-hat-wearin’ work-horse of a farm train, Faye’s job is to move farm produce and animals, feed and fertilizer, as well as help out on the farms themselves. `,
              audio: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Faye/FAYE_CTA_REV1.wav`,
              img: `${cdnBase}meetTheHeros/trains/CAROUSEL/trains-FAYE.png`,
              bioImg: `${cdnBase}meetTheHeros/trains/BIO+PAGES/bio-FAYE.png`,
              bioCircle: `${cdnBase}meetTheHeros/trains/MEET+THE+OTHER+TRAINS/Faye-Circle.png`,
              grid: [
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Faye/Faye+Image+2.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Faye/Faye+Image+3.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Faye/Faye+Image+4.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Faye/Faye+Image+5.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Faye/gallery-FAYE-musicvideo-thumb.jpg`,
                movie: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Faye/FAYE_FarmerInTheDell_H264_20Mbps_Clean_200720_vimeo.mp4`,
              },
            },
            {
              name: `Rescue Red`,
              header: `He'll keep you safe!`,
              copy: `Rescue Red will save the day, the delivery, and the cat in the tree. Rescue Red is the fire engine/EMT train that makes breath taking rescues and takes care of safety all over town. `,
              audio: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Red/Red_CTA_Rev_Feb._4_2020.wav`,
              img: `${cdnBase}meetTheHeros/trains/CAROUSEL/trains-RED.png`,
              bioImg: `${cdnBase}meetTheHeros/trains/BIO+PAGES/bio-RED.png`,
              bioCircle: `${cdnBase}meetTheHeros/trains/MEET+THE+OTHER+TRAINS/Red-Circle.png`,
              grid: [
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Red/Red+Image+2.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Red/Red+Image+3.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Red/Red+Image+4.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Red/Red+Image+5.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Red/Red+Image+1-+Video+Thumb.jpg`,
                movie: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Red/Red_Video+Clip.mov`,
              },
            },
            {
              name: `Peoplemover Penny`,
              header: `The bubbliest train!`,
              copy: `Peoplemover Penny will get you there with a smile! A bubbly morning person of a train, Penny’s goal is to get kids where they need to go with smiles on their faces. `,
              audio: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Penny/Penny_CTA_REV2.wav`,
              img: `${cdnBase}meetTheHeros/trains/CAROUSEL/trains-PENNY.png`,
              bioImg: `${cdnBase}meetTheHeros/trains/BIO+PAGES/bio-PENNY.png`,
              bioCircle: `${cdnBase}meetTheHeros/trains/MEET+THE+OTHER+TRAINS/Penny-Circle.png`,
              grid: [
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Penny/Penny+Image+1.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Penny/Penny+Image+3.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Penny/Penny+Image+4.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Penny/Penny+Image+5.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Penny/gallery-PENNY-musicvideo-thumb.jpg`,
                movie: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Penny/PENNY_PennyIsHerName_Master_H264_20Mbps_Clean_200814_vimeo.mp4`,
              },
            },
            {
              name: `Flicker`,
              header: `Little train, big dreams!`,
              copy: `Flicker will so save you, too! Flicker is the wee engine with the wee hat who looks up to his big brother, Red, and is in charge of small rescues he can handle easily. `,
              audio: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Flicker/Flicker_CTA_05_Faster_BQ.wav`,
              img: `${cdnBase}meetTheHeros/trains/CAROUSEL/trains-FLICKER.png`,
              bioImg: `${cdnBase}meetTheHeros/trains/BIO+PAGES/bio-FLICKER.png`,
              bioCircle: `${cdnBase}meetTheHeros/trains/MEET+THE+OTHER+TRAINS/Flicker-Circle.png`,
              grid: [
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Flicker/Flicker+Image+1.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Flicker/Flicker+Image+2.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Flicker/Flicker+Image+4.jpg`,
                `${cdnBase}meetTheHeros/trains/BIO+PAGES/Flicker/Flicker+Image+5.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Flicker/gallery-FLICKER-musicvideo-thumb.jpg`,
                movie: `${cdnBase}meetTheHeros/trains/BIO+PAGES/Flicker/FLICKER_FlickerHasALittleDog_Master_H264_20Mbps_Clean_201001_vimeo.mp4`,
              },
            },
            {
              name: `MANDY MAIL`,
              header: `A Carload of Train Trouble`,
              copy: `Mandy Mail is a carload of train trouble, special delivery. An express delivery train with an important role on the team - delivering packages and mail all over town – Mandy always thinks she can do more.`,
              audio: `${cdnBase}sept+2021/Bio+-+Mandy+Mail/TT1+Mandy+Mail+CTA+Melody+Long+Vsn+REV3.wav`,
              img: `${cdnBase}sept+2021/Bio+-+Mandy+Mail/mandy+mail.png`,
              bioImg: `${cdnBase}sept+2021/Bio+-+Mandy+Mail/bio-MANDYMAIL.png`,
              bioCircle: `${cdnBase}sept+2021/Bio+-+Mandy+Mail/mandy-circle.png`,
              grid: [
                `${cdnBase}sept+2021/Bio+-+Mandy+Mail/Mandy+Image+1.jpg`,
                `${cdnBase}sept+2021/Bio+-+Mandy+Mail/Mandy+Image+2.jpg`,
                `${cdnBase}sept+2021/Bio+-+Mandy+Mail/Mandy+Image+4.jpg`,
                `${cdnBase}sept+2021/Bio+-+Mandy+Mail/Mandy+Image+5.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}sept+2021/Bio+-+Mandy+Mail/Mandy+Image+3-videothumb.jpg`,
                movie: `${cdnBase}sept+2021/Bio+-+Mandy+Mail/Mandy+Video+Clip.mp4`,
              },
            },
          ],
        },
        {
          display: "The Kids",
          id: "kids",
          meet: "Meet the other Kids!",
          bgImg: `${cdnBase}meetTheHeros/kids/kids-BG.jpg`,
          characters: [
            {
              name: `Liza`,
              header: `"You are Liza-certified!"`,
              copy: `Liza is a train whisperer. She knows everything about what’s under a train’s hood, especially their heart. Mechanical, methodical, and meticulous, Liza loves tinkering and poking around to see how things work, and nothing is more satisfying than giving every train a quick tune up before it hits the tracks. `,
              audio: `${cdnBase}meetTheHeros/kids/LIZA/LIZA_phrase.wav`,
              img: `${cdnBase}meetTheHeros/kids/kids-LIZA.png`,
              bioImg: `${cdnBase}meetTheHeros/kids/LIZA/bio-LIZA.png`,
              bioCircle: `${cdnBase}meetTheHeros/kids/carousel-LIZA.png`,
              grid: [
                `${cdnBase}meetTheHeros/kids/LIZA/gallery-LIZA-01.jpg`,
                `${cdnBase}meetTheHeros/kids/LIZA/gallery-LIZA-02.jpg`,
                `${cdnBase}meetTheHeros/kids/LIZA/gallery-LIZA-03.jpg`,
                `${cdnBase}meetTheHeros/kids/LIZA/gallery-LIZA-05.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}meetTheHeros/kids/LIZA/gallery-LIZA-video-thumb.jpg`,
                movie: `${cdnBase}meetTheHeros/kids/LIZA/LIZA_clip.mp4`,
              },
            },
            {
              name: `Max`,
              header: `"Let's make tracks!"`,
              copy: `Max isn’t just his name, it’s also his personality. The leader of the team and the main kid in charge, Max is always in overdrive, multi- tasking and keeping his eye on the big picture. `,
              audio: `${cdnBase}meetTheHeros/kids/MAX/MAX_phrase.wav`,
              img: `${cdnBase}meetTheHeros/kids/kids-MAX.png`,
              bioImg: `${cdnBase}meetTheHeros/kids/MAX/bio-MAX.png`,
              bioCircle: `${cdnBase}meetTheHeros/kids/carousel-MAX.png`,
              grid: [
                `${cdnBase}meetTheHeros/kids/MAX/gallery-MAX-01.jpg`,
                `${cdnBase}meetTheHeros/kids/MAX/gallery-MAX-02.jpg`,
                `${cdnBase}meetTheHeros/kids/MAX/gallery-MAX-03.jpg`,
                `${cdnBase}meetTheHeros/kids/MAX/gallery-MAX-04.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}meetTheHeros/kids/MAX/gallery-MAX-01.jpg`,
                movie: `${cdnBase}meetTheHeros/kids/MAX/MAX_clip.mp4`,
              },
            },
            {
              name: `Nico`,
              header: `"According to my calculations..."`,
              copy: `Nico keeps everyone on track – literally. With a track control board full of blinking lights and tricky switches and maps of every nook and cranny in Tracksville, Nico loves nothing more than choreographing the gorgeous ballet that is trains moving along the tracks. `,
              audio: `${cdnBase}meetTheHeros/kids/NICO/NICO.wav`,
              img: `${cdnBase}meetTheHeros/kids/kids-NICO.png`,
              bioImg: `${cdnBase}meetTheHeros/kids/NICO/bio-NICO.png`,
              bioCircle: `${cdnBase}meetTheHeros/kids/carousel-NICO.png`,
              grid: [
                `${cdnBase}meetTheHeros/kids/NICO/gallery-NICO-01.jpg`,
                `${cdnBase}meetTheHeros/kids/NICO/gallery-NICO-02.jpg`,
                `${cdnBase}meetTheHeros/kids/NICO/gallery-NICO-03.jpg`,
                `${cdnBase}meetTheHeros/kids/NICO/gallery-NICO-04.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}meetTheHeros/kids/NICO/gallery-NICO-video-thumb.jpg`,
                movie: `${cdnBase}meetTheHeros/kids/NICO/NICO_clip.mp4`,
              },
            },
            {
              name: `Jubilee`,
              header: `"She's got you covered!"`,
              copy: `In the square you might run into Jubilee, the kid who knows Central Square Station like no other! With her partyplanner clipboard and zippy wheelchair. Jubilee has thought of everything the town might need.`,
              audio: ``,
              img: `${cdnBase}meetTheHeros/kids/kids-JUBILEE.png`,
              bioImg: `${cdnBase}meetTheHeros/kids/JUBILEE/bio-JUBILEE.png`,
              bioCircle: `${cdnBase}meetTheHeros/kids/carousel-JUBILEE.png`,
              grid: [
                `${cdnBase}meetTheHeros/kids/JUBILEE/gallery-JUBILEE-01.jpg`,
                `${cdnBase}meetTheHeros/kids/JUBILEE/gallery-JUBILEE-02.jpg`,
                `${cdnBase}meetTheHeros/kids/JUBILEE/gallery-JUBILEE-03.jpg`,
                `${cdnBase}meetTheHeros/kids/JUBILEE/gallery-JUBILEE-04.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}meetTheHeros/kids/JUBILEE/gallery-JUBILEE-video-thumb.jpg`,
                movie: `${cdnBase}meetTheHeros/kids/JUBILEE/JUBILEE_clip.mp4`,
              },
            },
          ],
        },
        {
          display: "The Animals",
          id: "critters",
          meet: "Meet the other Animals!",
          bgImg: `${cdnBase}meetTheHeros/critters/critters-BG.jpg`,
          characters: [
            {
              name: `Popstar Piggies `,
              header: `Style AND personality!`,
              copy: `Flashy, Splashy, Glitzy and Larry are no ordinary pigs. They are true talents. They dance – everything from boy-band running-man moves to ballet. They model – strutting down runways, duck-facing at photo shoots. `,
              audio: ``,
              img: `${cdnBase}meetTheHeros/critters/critters-pigs-mobile.png`,
              bioImg: `${cdnBase}meetTheHeros/critters/POPSTAR+PIGGIES/bio-PIGGIES.png`,
              bioCircle: `${cdnBase}meetTheHeros/critters/carousel-PIGGIES.png`,
              grid: [
                `${cdnBase}meetTheHeros/critters/POPSTAR+PIGGIES/gallery-PIGGIES-01.jpg`,
                `${cdnBase}meetTheHeros/critters/POPSTAR+PIGGIES/gallery-PIGGIES-02.jpg`,
                `${cdnBase}meetTheHeros/critters/POPSTAR+PIGGIES/gallery-PIGGIES-03.jpg`,
                `${cdnBase}meetTheHeros/critters/POPSTAR+PIGGIES/gallery-PIGGIES-04.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}meetTheHeros/critters/POPSTAR+PIGGIES/gallery-POPSTARPIGGIES-musicvideo-thumb.jpg`,
                movie: `${cdnBase}meetTheHeros/critters/POPSTAR+PIGGIES/POPSTARPIGGIES_ItsThePopstarPiggies_Master_H264_20Mbps_Clean_201001_vimeo.mp4`,
              },
            },
            {
              name: `Goaty`,
              header: `Worst place at the worst time.`,
              copy: `A famously stubborn mountain goat, Goaty likes to block the tracks, sometimes kick stuff off his mountain which causes no end of trouble he shows up out of nowhere with his unique brand of wild card villainy. `,
              audio: ``,
              img: `${cdnBase}meetTheHeros/critters/critters-goaty-mobile.png`,
              bioImg: `${cdnBase}meetTheHeros/critters/GOATY/bio-GOATY.png`,
              bioCircle: `${cdnBase}meetTheHeros/critters/carousel-GOATY.png`,
              grid: [
                `${cdnBase}meetTheHeros/critters/GOATY/gallery-GOATY-01.jpg`,
                `${cdnBase}meetTheHeros/critters/GOATY/gallery-GOATY-02.jpg`,
                `${cdnBase}meetTheHeros/critters/GOATY/gallery-GOATY-03.jpg`,
                `${cdnBase}meetTheHeros/critters/GOATY/gallery-GOATY-04.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}meetTheHeros/critters/GOATY/gallery-GOATY-video-thumb.jpg`,
                movie: `${cdnBase}meetTheHeros/critters/GOATY/GOATY_clip.mp4`,
              },
            },
            {
              name: `Diesel `,
              header: `So fluffy and lovable!`,
              copy: `HQ’s puppy mascot, Diesel, gallops about on his big puppy paws, getting into big puppy trouble. `,
              audio: ``,
              img: `${cdnBase}meetTheHeros/critters/critters-diesel-mobile.png`,
              bioImg: `${cdnBase}meetTheHeros/critters/DIESEL/bio-DIESEL.png`,
              bioCircle: `${cdnBase}meetTheHeros/critters/carousel-DIESEL.png`,
              grid: [
                `${cdnBase}meetTheHeros/critters/DIESEL/gallery-DIESEL-01.jpg`,
                `${cdnBase}meetTheHeros/critters/DIESEL/gallery-DIESEL-02.jpg`,
                `${cdnBase}meetTheHeros/critters/DIESEL/gallery-DIESEL-03.jpg`,
                `${cdnBase}meetTheHeros/critters/DIESEL/gallery-DIESEL-04.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}meetTheHeros/critters/DIESEL/gallery-DIESEL-video-thumb.jpg`,
                movie: `${cdnBase}meetTheHeros/critters/DIESEL/DIESEL_clip.mp4`,
              },
            },
            {
              name: `The Geese`,
              header: `Ready for action!`,
              copy: `This determined flock of helmeted aviator geese always fly together and are ready to jump into action at a moment’s notice! Look up in the sky and you’ll see the geese in a perfect V formation, in search of their next big adventure…or meal!`,
              audio: ``,
              img: `${cdnBase}meetTheHeros/critters/critters-2-geese-mobile.png`,
              bioImg: `${cdnBase}meetTheHeros/critters/GEESE/bio-GEESE.png`,
              bioCircle: `${cdnBase}meetTheHeros/critters/carousel-GEESE.png`,
              grid: [
                `${cdnBase}meetTheHeros/critters/GEESE/gallery-GEESE-01.jpg`,
                `${cdnBase}meetTheHeros/critters/GEESE/gallery-GEESE-02.jpg`,
                `${cdnBase}meetTheHeros/critters/GEESE/gallery-GEESE-03.jpg`,
                `${cdnBase}meetTheHeros/critters/GEESE/gallery-GEESE-04.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}meetTheHeros/critters/GEESE/gallery-GEESE-video-thumb.jpg`,
                movie: `${cdnBase}meetTheHeros/critters/GEESE/GEESE_clip.mp4`,
              },
            },
            {
              name: `Cuckoo Chickens`,
              header: `The troublemaking trio!`,
              copy: `The cuckoo chickens are a hilarious trio of squabbling fowl who always get into trouble, both on and off the farm. Clumsy, impulsive and playful, our feathered friends will stumble and “b-gawk” their way into your hearts!`,
              audio: ``,
              img: `${cdnBase}meetTheHeros/critters/critters-2-chickens-mobile.png`,
              bioImg: `${cdnBase}meetTheHeros/critters/CHICKENS/bio-CHICKENS.png`,
              bioCircle: `${cdnBase}meetTheHeros/critters/carousel-CHICKENS.png`,
              grid: [
                `${cdnBase}meetTheHeros/critters/CHICKENS/gallery-CHICKENS-01.jpg`,
                `${cdnBase}meetTheHeros/critters/CHICKENS/gallery-CHICKENS-02.jpg`,
                `${cdnBase}meetTheHeros/critters/CHICKENS/gallery-CHICKENS-03.jpg`,
                `${cdnBase}meetTheHeros/critters/CHICKENS/gallery-CHICKENS-04.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}meetTheHeros/critters/CHICKENS/gallery-CHICKENS-video-thumb.jpg`,
                movie: `${cdnBase}meetTheHeros/critters/CHICKENS/CHICKENS_clip.mp4`,
              },
            },
            {
              name: `The Cows`,
              header: `Udderly wild!`,
              copy: `These adrenaline seeking, fun loving cows are always on the mooove. If there’s a coaster to ride or a party to attend , they’re always first in line. These bovine buddies make life at Farm Station an udderly wild time!`,
              audio: ``,
              img: `${cdnBase}meetTheHeros/critters/critters-2-cow-mobile.png`,
              bioImg: `${cdnBase}meetTheHeros/critters/COWS/bio-COWS.png`,
              bioCircle: `${cdnBase}meetTheHeros/critters/carousel-COW.png`,
              grid: [
                `${cdnBase}meetTheHeros/critters/COWS/gallery-COWS-01.jpg`,
                `${cdnBase}meetTheHeros/critters/COWS/gallery-COWS-02.jpg`,
                `${cdnBase}meetTheHeros/critters/COWS/gallery-COWS-03.jpg`,
                `${cdnBase}meetTheHeros/critters/COWS/gallery-COWS-04.jpg`,
              ],
              movieTile: {
                thumb: `${cdnBase}meetTheHeros/critters/COWS/gallery-COWS-video-thumb.jpg`,
                movie: `${cdnBase}meetTheHeros/critters/COWS/COWS_clip.mp4`,
              },
            },
          ],
        },
      ],
    },
    printables: {
      heading: `Free Activities`,
      copy1: `Your kids will love these MIGHTY activities!`,
      copy2: `Download them for free now!`,
      cta: `Download`,
      pdfs: [
        {
          img: `${cdnBase}printables/Mighty-Express-Coliring-Sheet-1-Thumbnail.jpg`,
          pdf: `${cdnBase}printables/Mighty-Express-Coliring-Sheet.pdf`,
          copy: `Coloring - Freight Nate`,
        },
        {
          img: `${cdnBase}printables/Mighty-Express-Coliring-Sheet-1-Thumbnail-DIY.png`,
          pdf: `${cdnBase}printables/Mighty+Express-Activity_DIY.pdf`,
          copy: `DIY -  Build Freight Nate`,
        },
        {
          img: `${cdnBase}printables/Mighty-Express-Coliring-Sheet-1-Thumbnail-Maze.png`,
          pdf: `${cdnBase}printables/Mighty+Express_Activity_Game.pdf`,
          copy: `Game - Track Maze`,
        },
        {
          img: `${cdnBase}fall/Activity+Sheets/Mighty+Express-Activity+Sheets_Fall_Coloring-min.jpg`,
          pdf: `${cdnBase}fall/Activity+Sheets/Mighty+Express-Activity+Sheets_Fall_Coloring.pdf`,
          copy: `DIY`,
        },
        {
          img: `${cdnBase}fall/Activity+Sheets/Mighty+Express-Activity+Sheets_Fall_ConnectDots-min.jpg`,
          pdf: `${cdnBase}fall/Activity+Sheets/Mighty+Express-Activity+Sheets_Fall_ConnectDots.pdf`,
          copy: `Connect the Dots`,
        },
        {
          img: `${cdnBase}fall/Activity+Sheets/Mighty+Express-Activity+Sheets_Fall_SuperNateMask-min.jpg`,
          pdf: `${cdnBase}fall/Activity+Sheets/Mighty+Express-Activity+Sheets_Fall_SuperNateMask.pdf`,
          copy: `Coloring`,
        },
      ],
    },
    seasonal: {
      heading: `RIDE INTO CHUG-A-LOVE DAY `,
      heading2: `WITH MIGHTY EXPRESS!`,
      bg: `${cdnBase}valentines_update/chugalove-bg.jpg`,
      trailer: {
        heading: `Chug-A-Love Day`,
        subheading: `Premiering on Netflix Feb 2nd, 2021`,
        copy: `It’s Chug-A-Love day in Tracksville and Mandy Mail can’t wait to deliver cards to everyone in town! But when her delivery goes off the rails, she must work together with her best pal Flicker to save the day and learn the true meaning of friendship.`,
        // logo: `${cdnBase}Holiday+Update/SPN_MightyExpress_Christmas_LOGO_FIN01_cropsmall.png`,
        img: `${cdnBase}valentines_update/chugalove-trailer.png`,
        cta: {
          // src: `${cdnBase}fall/Nate's+Fright+Night!+FULL+EPISODE+-+Mighty+Express+Official.mp4`,
          src: `https://youtu.be/6_Fw2LLbNCo`,
          copy: `Watch Trailer`,
        },
      },
      // singleDownload:{
      //   copy: `Print out these MIGHTY fine ornaments and gift tags for your kids to color and decorate!`,
      //   img: `${cdnBase}Holiday+Update/diy-ornaments-desktop.png`,
      //   cta: {
      //     copy: `download`,
      //     src: `${cdnBase}Holiday+Update/Mighty+Express-Activity+Sheets_Holiday_OrnamentsTags.pdf`
      //   }
      // },
      downloads: {
        heading: "Keep your kids busy with these free<br>Valentine-themed activities!",
        // heading2: "Download them for free!",
        // download: "download",
        pdfs: [
          {
            img: `${cdnBase}valentines_update/Activity+Sheets/MightyExpress-ActivitySheets_Valentines_Cards1.jpg`,
            pdf: `${cdnBase}valentines_update/Activity+Sheets/Mighty+Express-Activity+Sheets_Valentines_Cards1.pdf`,
            copy: `DIY - Valentine's Card`
          },
          {
            img: `${cdnBase}valentines_update/Activity+Sheets/MightyExpress-ActivitySheets_Valentines_Cards2.jpg`,
            pdf: `${cdnBase}valentines_update/Activity+Sheets/Mighty+Express-Activity+Sheets_Valentines_Cards2.pdf`,
            copy: `DIY - Valentine's Card`
          },
          {
            img: `${cdnBase}valentines_update/Activity+Sheets/MightyExpress-ActivitySheets_Valentines_WordSearch.jpg`,
            pdf: `${cdnBase}valentines_update/Activity+Sheets/Mighty+Express-Activity+Sheets_Valentines_WordSearch.pdf`,
            copy: `Games - Word Search`
          },
        ],
      },
      app: {
        icon: `${cdnBase}valentines_update/app-icon.png`,
        copy: `Feel the love with the Valentine's Day update in the Mighty Express app! Explore Tracksville with your train BFFs and play some MIGHTY fun games`,
        ctas: [
          {
            alt: `ios app`,
            img: `${cdnBase}app/apple-store.svg`,
            src: `https://apps.apple.com/app/mighty-express-play-learn/id1528383439`
          },
          {
            alt: `android app`,
            img: `${cdnBase}app/google-store.svg`,
            src: `https://play.google.com/store/apps/details?id=com.spinmaster.mightyexpressgamesworld`
          }
        ],
        slides: [
          {
            src: `${cdnBase}valentines_update/Scr1_Tablet_1.jpg`,
            alt: ``
          },
          {
            src: `${cdnBase}valentines_update/Scr1_Tablet_2.jpg`,
            alt: ``
          },
          {
            src: `${cdnBase}valentines_update/Scr1_Tablet_3.jpg`,
            alt: ``
          },
          {
            src: `${cdnBase}valentines_update/Scr1_Tablet_4.jpg`,
            alt: ``
          }
        ]
      },
      zoom: {
        heading: "Zoom Background",
        img: `${cdnBase}valentines_update/chugalove-zoom-thumb.jpg`,
        cta: {
          copy: `download`,
          src: `${cdnBase}valentines_update/chugalove-zoom-background.jpg`,
        },
      },
      // stickers: {
      //   heading:
      //     "Find these super fun stickers on Giphy!<br>Follow @MightyExpressOfficial and tag us when we make an appearance during your holiday celebrations! ",
      //   link: "https://giphy.com/spinmaster/",
      //   img: [
      //     `${cdnBase}Holiday+Update/GIFs/hohoho-santa.gif`,
      //     `${cdnBase}Holiday+Update/GIFs/mandy-christmas.gif`,
      //     `${cdnBase}Holiday+Update/GIFs/nico-wrapped.gif`,
      //   ],
      //   cta: {
      //     copy: `download`,
      //     src: `https://giphy.com/spinmaster/`,
      //   },
      // },
    },
    support: {
      title: "Support",
      subTitle: "Support",
    },
    toys: {
      title: "Toys",
      subTitle: "Toys",
      learn: "learn",
      more: "more",
      toys_banner: `${cdnBase}toys/TOYS_Banner.jpg`,
      toys_banner_alt: "banner with mighty express trains"
    },
    toy: {
      title: "Toy",
      subTitle: "Toy",
      backToToys: "Back to Toys",
      features: "Features",
      image: "Image",
      contents: "Contents",
      whereToBuy: "Where to Buy",
      instructions: "Instructions",
      videoInstructions: "Video Instructions",
      brandSite: "brand site",
      buyNow: "Buy Now",
      retailers: "Retailers",
      readmore: "Read More..."
    },
    videos: {
      title: "Videos",
      subTitle: "Videos",
      playVideo: "Play Video",
      playButton_Alt: "play button",
      defaultVideoIndex: 0,
      categories: "Categories",
      catList: ["all", "commercials", "influencer"],
      videoList: [
        {
          title: "Commercial 1",
          video: `${cdnBase}videos/CandyLocks_Recut_30_v3.13a.mp4`,
          thumb: "https://via.placeholder.com/400x250",
          type: "default",
          categories: ["all", "commercials"],
        },
        {
          title: "Commercial 2",
          video: `${cdnBase}videos/CandyLocks_Recut_30_v3.13a.mp4`,
          thumb: "https://via.placeholder.com/400x250",
          type: "default",
          categories: ["all", "commercials"],
        },
        {
          title: "influencer Video",
          video: `${cdnBase}videos/CandyLocks_Recut_30_v3.13a.mp4`,
          thumb: "https://via.placeholder.com/400x250",
          type: "default",
          categories: ["all", "influencer"],
        },
        // {
        //   title:'Youtube Video',
        //   video:`Sx3ORAO1Y6s`,
        //   thumb: 'https://via.placeholder.com/400x250',
        //   type: 'youtube',
        //   categories: ['all','influencer'],
        // }
      ],
    },
    nomatch: {
      title: "Page Not Found",
    },
  },
};



// WEBPACK FOOTER //
// ./src/il8n/en_ca/index.js